import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Toast=(msg,type)=>{

    return toast(
        msg, {
        position: "top-right",
        type,
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: true,
    });
}
export default Toast;